import { NgModule }                         from '@angular/core';
import { CommonModule }                     from '@angular/common';
import { RouterModule }                     from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MaterialModule } from '../material/material.module';
import { PipesModule }    from '../pipes/pipes.module';
import { ImageModule }    from '../image/image.module';
import { IconsModule }    from '../icons/icons.module';

import { ThemeCardComponent }          from './theme-card/theme-card.component';
import { TaskCardComponent }           from './task-card/task-card.component';
import { StudentCardComponent }        from './student-card/student-card.component';
import { EvolutionCardComponent }      from './evolution-card/evolution-card.component';
import { AnchorModule }                from '../anchor/anchor.module';
import { TaskSheetCardComponent }      from './task-sheet-card/task-sheet-card.component';
import { ProofreaderRpaCardComponent } from './proofreader-rpa-card/proofreader-rpa-card.component';
import { ManualsCardComponenet }       from './manuals-card/manuals-card.component';
import { CardComponent }               from './card/card.component';
import { LoadingModule }               from '@shared/loading/loading.module';


@NgModule({
  declarations: [
    ThemeCardComponent,
    ManualsCardComponenet,
    TaskCardComponent,
    StudentCardComponent,
    EvolutionCardComponent,
    TaskSheetCardComponent,
    ProofreaderRpaCardComponent,
    CardComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    PipesModule,
    IconsModule,
    ImageModule,
    AnchorModule,
    LoadingModule,
  ],
  exports:      [
    ThemeCardComponent,
    ManualsCardComponenet,
    TaskCardComponent,
    StudentCardComponent,
    EvolutionCardComponent,
    TaskSheetCardComponent,
    ProofreaderRpaCardComponent,
    CardComponent,
  ],
})
export class CardsModule {}
